import { render, staticRenderFns } from "./GoogleMapLoader.vue?vue&type=template&id=2b9d3a54&"
import script from "./GoogleMapLoader.vue?vue&type=script&lang=js&"
export * from "./GoogleMapLoader.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMapLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports